/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-02 17:27:05
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import useGiftCardForm from '@root/hooks/giftCard/useGiftCardForm';
import Button from '@root/components/Button';
import Input from '@root/components/Input';
import './index.less';

const GiftCard = () => {
  const { t } = useTranslation();
  const {
    state: { checking, code, errorMsg },
    action: { onChangeCode, onCheckCode, onClickUseRules },
  } = useGiftCardForm();

  return (
    <>
      <div className="gift-card-form">
        <Input
          className="fill large"
          value={code}
          onChange={onChangeCode}
          placeholder={t('gift_card_placeholder')}
          maxLength={10}
          edit
          clear
        />
        <div className="gift-card-tip">
          {errorMsg && <span className="msg">{errorMsg}</span>}
          <span className="rule" onClick={onClickUseRules}>
            {t('gift_card_use_rules')}
          </span>
        </div>
        <Button
          disabled={!!errorMsg || code.length !== 10}
          loading={checking}
          onClick={onCheckCode}
        >
          {t('gift_card_redeem')}
        </Button>
      </div>
    </>
  );
};

export default GiftCard;
